import React from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

export const Layout = ({ children, bare = false }) => (
    <div className="min-h-screen flex flex-col bg-ivory grain">
        <Nav />
        <main className="flex-1 pt-16">{children}</main>
        {!bare && <Footer />}
    </div>
);

const Loader = () => (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="h-8 w-8 rounded-full border-2 border-forest/20 border-t-forest animate-spin" />
    </div>
);

export const ProtectedRoute = ({ children }) => {
    const { user } = useApp();
    if (user === null) return <Loader />;
    if (!user) return <Navigate to="/login" replace />;
    return children;
};

export const AdminRoute = ({ children }) => {
    const { user } = useApp();
    if (user === null) return <Loader />;
    if (!user) return <Navigate to="/login" replace />;
    if (user.role !== "admin") return <Navigate to="/" replace />;
    return children;
};

export default Layout;
